import { useState } from 'react'
import isEmpty from 'lodash/isEmpty'

const DELAY = 2500

export const useToast = () => {
  const [visibleToast, setVisibleToast] = useState({})

  const hideToast = () => {
    clearTimeout(visibleToast.timeoutId)
    setVisibleToast({})
  }

  const showToast = ({ theme, message, duration = DELAY }) => {
    if (!isEmpty(visibleToast)) {
      hideToast()
    }

    const timeoutId = setTimeout(hideToast, duration)
    setVisibleToast({ theme, message, timeoutId })
  }

  return {
    visibleToast,
    showToast,
    hideToast,
  }
}
